import { CURRENT_INSTANCE } from '@lib/utils';
import { useTranslation } from 'react-i18next';

function MedicalInfoContent() {
  const { t } = useTranslation();
  const medInfoLink = CURRENT_INSTANCE.medInfoLink;
  const medInfoText = CURRENT_INSTANCE.medInfoText;

  return (
    <>
      <div>{t('common.contact')}</div>
      <div>
        <div className="whitespace-pre-wrap">{medInfoText}</div>
        <div>
          <a href={medInfoLink} target="_blank" rel="noopener noreferrer">
            {t('common.medical_inquiries')}
          </a>
        </div>
      </div>
    </>
  );
}

export default MedicalInfoContent;
